/**
 * 최근 검색 조건 저장/불러오기
 *
 * 저장 키:
 *   vip_recent_datetime   — 마지막 이용 일시 (공통)
 *   vip_recent_departure  — 마지막 출발지 주소 (공항 제외 공통)
 *   vip_recent_{type}     — 서비스별 추가 데이터 (departure, people, venue 등)
 *
 * 이용 일시가 현재보다 과거면 내일 10:00으로 대체
 */

const KEY_DATETIME  = 'vip_recent_datetime';
const KEY_DEPARTURE = 'vip_recent_departure';
const svcKey = (type) => `vip_recent_${type}`;

function getTomorrowAt10() {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}T10:00`;
}

function resolveDateTime(stored) {
  if (!stored) return getTomorrowAt10();
  try {
    return new Date(stored).getTime() > Date.now() ? stored : getTomorrowAt10();
  } catch {
    return getTomorrowAt10();
  }
}

/**
 * 최근 검색 조건 불러오기
 * @param {string} serviceType  서비스 타입 (airport | golf | ski | hospital | pet | business)
 * @param {number} defaultPeople 인원 기본값 (서비스별 상이)
 */
export function loadRecentSearch(serviceType, defaultPeople = 4) {
  try {
    const storedDate   = localStorage.getItem(KEY_DATETIME) || '';
    const dateTime     = resolveDateTime(storedDate);
    const commonDep    = localStorage.getItem(KEY_DEPARTURE) || '';
    const svcData      = JSON.parse(localStorage.getItem(svcKey(serviceType)) || 'null') || {};

    /* departure: 서비스별 저장값 우선, 없으면 공통 출발지 (공항 서비스 제외) */
    const departure = svcData.departure || (serviceType !== 'airport' ? commonDep : '');
    const people    = svcData.people    || defaultPeople;

    return { dateTime, departure, people, ...svcData };
  } catch {
    return { dateTime: getTomorrowAt10(), departure: '', people: defaultPeople };
  }
}

/**
 * 최근 검색 조건 저장
 * @param {string} serviceType
 * @param {object} data  { departure, dateTime, people, ...serviceSpecific }
 */
export function saveRecentSearch(serviceType, data) {
  try {
    const { departure, dateTime, people, ...rest } = data;
    if (dateTime)              localStorage.setItem(KEY_DATETIME, dateTime);
    if (departure && serviceType !== 'airport') {
      localStorage.setItem(KEY_DEPARTURE, departure);
    }
    localStorage.setItem(svcKey(serviceType), JSON.stringify({ departure, people, ...rest }));
  } catch {
    /* localStorage 접근 불가 시 무시 */
  }
}
